/* DON'T EDIT THIS FILE: edit original and run build again */ export enum EntityType {
  Any = "any",
  OnlyHumans = "onlyHumans",
  OnlyCompanies = "onlyCompanies",
}
